import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFeature } from '@/hooks';
import { useAppSelector } from '@/redux';

import HipayCardForm from '@/components/checkout/payMode/HipayCardForm';
import CheckboxV2 from '@/components/common/CheckboxV2';
import { FEATURES } from '@/constants/features';

export const HipayNewCard = ({ t, updateCardInfo, isActive, locale, paymentMode, setBrowserInfos, setFingerprint }) => {
  const storeConf = useAppSelector(({ root }) => root.storeConf);
  const [saveCreditCard, setSaveCreditCard] = useState(false);
  const [cardInfo, setCardInfo] = useState();
  const isFeatureAddCardsEnable = useFeature(storeConf, FEATURES.MODULE_ADD_CARDS);

  useEffect(() => {
    if (isActive) {
      updateCardInfo(cardInfo, saveCreditCard);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardInfo, saveCreditCard, isActive]);

  return (
    <div className="cards-form" data-test-id="hipay-new-card" data-cs-mask>
      <HipayCardForm
        t={t}
        sendCardInfo={setCardInfo}
        columnAllowed={true}
        locale={locale}
        hipayLogin={paymentMode.hipayLogin}
        hipayPassword={paymentMode.hipayPassword}
        enableSetBrowserInfos
        setBrowserInfos={setBrowserInfos}
        setFingerprint={setFingerprint}
      />
      {/* {isFeatureAddCardsEnable &&*/}
      {/*  <CheckboxV2*/}
      {/*    id="save"*/}
      {/*    label={t('checkout:payMode.shouldSaveCreditCard')}*/}
      {/*    onChange={() => setSaveCreditCard(!saveCreditCard)}*/}
      {/*  />*/}
      {/* }*/}
    </div>
  );
};

HipayNewCard.propTypes = {
  t: PropTypes.func.isRequired,
  updateCardInfo: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  paymentMode: PropTypes.shape({
    hipayLogin: PropTypes.string,
    hipayPassword: PropTypes.string
  }).isRequired,
  setBrowserInfos: PropTypes.func.isRequired,
  setFingerprint: PropTypes.func
};

export default HipayNewCard;
